import {
  faFile,
  faFileAudio,
  faFileCode,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord
} from '@fortawesome/pro-duotone-svg-icons'

export function useFileIcon() {
  const getFileIcon = (url: string) => {
    if (!url)
      return faFile

    const extension = url.split('.').pop()?.toLowerCase()

    if (!extension)
      return faFile

    // Image files
    if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(extension)) {
      return faFileImage
    }

    // Audio files
    if (['mp3', 'wav', 'ogg', 'aac'].includes(extension)) {
      return faFileAudio
    }

    // Video files
    if (['mp4', 'webm', 'avi', 'mov', 'wmv'].includes(extension)) {
      return faFileVideo
    }

    // Document files
    if (extension === 'pdf') {
      return faFilePdf
    }

    if (['doc', 'docx'].includes(extension)) {
      return faFileWord
    }

    if (['xls', 'xlsx'].includes(extension)) {
      return faFileExcel
    }

    if (['ppt', 'pptx'].includes(extension)) {
      return faFilePowerpoint
    }

    // Code files
    if (['html', 'css', 'js', 'ts', 'json', 'xml'].includes(extension)) {
      return faFileCode
    }

    // Default icon for unknown file types
    return faFile
  }

  return {
    getFileIcon
  }
}
